import { putData } from '../utils/fetch-api';

export const publishVideo = (videoId) => {
  return putData(`${process.env.REACT_APP_BASE_API_URL}arc-content/video/update/${videoId}/publish`, {}, true);
};
